module.exports = __webpack_public_path__ + "img/prize-type-6.69e175a8.png";